export default function SorenPulseAnswerCard({
  href,
  label,
  onOpen,
}: {
  href: string
  label?: string
  onOpen: (href: string) => void
}) {
  return (
    <button
      type="button"
      className="cr-btn dark"
      data-testid="soren-open-pulse"
      onClick={() => onOpen(href)}
    >
      {label || 'Open Pulse'}
    </button>
  )
}
